export const sampleProfiles = [
 {
  "locationPreference": "Philadelphia, PA",
  "yearsOfExperience": 24,
  "locumExperience": "Moderate (3-5 years)",
  "availability": {
    "desiredSchedule": "Flexible",
    "contractType": "W2",
    "shiftHours": ["6am-10am", "2pm-6pm"],
    "availabilityDate": "2025-01-23",
    "openToOnCall": false
  },
  "areasOfSpecialty": ["OB", "Pediatrics"],
  "caseTypes": ['General Surgery', 'Orthopedics', 'Neurosurgery'],
  "regionalAnesthesiaProficiency": ["Spinal", "Epidural"],
  "emrExperience": ['Epic', 'Cerner', 'Allscripts'],
  "preferredCareModel": ["CRNA-only Practice"],
  "preferredSettings": ['Outpatient', 'Inpatient'],
  "operatingRooms": ["Small (1-2)"],
  "traumaCenterLevel": ["Level II"],
  "facilityType": ["Hospital"],
  "desiredHourlyRates": ["$180 - $210", "$210 - $240"],
  "certifications": ["BLS", "ACLS", "PALS"],
  "activeAcrn": true,
  "otherSpecialCredentials": "Certificate XYZ",
  "stateLicenses": ["PA", "NY"],
  "name": "Jane Doe",
  "email": "jane@example.com",
  "phone": "+1234567890"
}
];